<template>
  <div class='activity'>
    <el-backtop :bottom="150">
      <img class="backtop" src="@/assets/renew/backtop.png" alt="">
    </el-backtop>
    <div class="activity-swiper">
      <el-carousel
        trigger="click"
        arrow="hover"
        :interval="0"
      >
        <el-carousel-item v-for="(item, index) in swpierList" :key="index">
          <div class="swiper-box">
            <div v-if="index == 0" class="oneSwiper">
              <img class="image" :src="item.adv_pic" alt="" srcset="" />
              <div class="signup">
                <div class="first-floor">
                  <div class="label">
                    <el-input v-model="signupForm.name" placeholder="请输入姓名" ></el-input>
                  </div>
                </div>
                <div class="first-floor">
                  <div class="label">
                    <el-input v-model="signupForm.mobile" placeholder="请输入手机号" maxlength="11" ></el-input>
                  </div>
                </div>
                <div class="first-floor">
                  <div class="label">
                    <el-input v-model="signupForm.address" placeholder="请输入所在地区" ></el-input>
                  </div>
                </div>
                <div class="submit-box">
                  <el-button class="loginBtn" type="success" :loading="isloading" @click="handleSignUp">{{isloading ? '立即预约...' : '立即预约'}}</el-button>
                </div>
              </div>
            </div>
            <a v-else :href="item.adv_url" target="_blank">
              <img class="image" :src="item.adv_pic" alt="" srcset="" />
            </a>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="quickentry">
      <div :class="['entry-item', { 'active': activeEntryIndex == index }]" v-for="(entry, index) in entryList" :key="'entry' + index" @click="goEntry(index)">
        <img class="icon" :src="entry.icon" alt="" srcset="" />
        <div class="name">{{ entry.name }}</div>
        <div class="line" v-if="activeEntryIndex == index"></div>
      </div>
    </div>
    <div class="container">
      <houseSelect v-if="activeEntryIndex == 0" ref="houseSelect"></houseSelect>
      <fuwu v-if="activeEntryIndex == 1"></fuwu>
      <renewCase v-if="activeEntryIndex == 3" @getInfo="goinfo"></renewCase>
    </div>
    <RenewInfo v-if="showPopup" :show="showPopup" :info="info" @close="showPopup = false"></RenewInfo>
    <SignupSuccess v-if="showSuccess" :show="showSuccess" :classIndex="7" showbtn @close="showSuccess = false" infoName="预约"></SignupSuccess>
  </div>
</template>

<script>
import Swiper1 from "@/components/swiper1";
import { isPhone } from '@/util/utils.js'
import { searchCase, doAdvertiseGeneralList } from '@/api/case.js'
import RenewInfo from '@/components/renewInfo.vue'
import SignupSuccess from '@/components/signupSuccess.vue'
import houseSelect from './component/houseSelect.vue'
import renewCase from './component/caseList.vue'
import fuwu from './component/fuwu.vue'
import axios from 'axios'
const md5 = require('js-md5')

export default {
  name: 'renew',
  components:{
    Swiper1,
    RenewInfo,
    SignupSuccess,
    houseSelect,
    renewCase,
    fuwu
  },
  props: {
    userInfo: {}
  },
  data() {
    return {
      form: {
        chk_type: 1,
        pageSize: 30,
        pageNum: 1
      },
      signupForm: {
        name: '',
        mobile: '',
        address: ''
      },
      list: [],
      info: '',
      activeEntryIndex: 0,
      isloading: false,
      showPopup: false,
      showActivitySignup: false,
      showSuccess: false,
      swpierList: [],
      entryList: [
        {
          icon: require('@/assets/renew/fangan.png'),
          name: '设计方案',
          index: 0
        },
        {
          icon: require('@/assets/renew/fuwu.png'),
          name: '服务标准',
          index: 1
        },
        {
          icon: require('@/assets/renew/jiazu.png'),
          name: '小森家族',
          index: 2
        },
        {
          icon: require('@/assets/renew/anli.png'),
          name: '焕新案例',
          index: 3
        },
      ]
    }
  },
  computed:{ },
  watch:{ },
  created() {
    this.getKvList()
    this.getList()
  },
  mounted() {
  },
  methods: {
    getKvList() {
      doAdvertiseGeneralList({
        adv_sign: 0,
        adv_type: '206',
        adv_state: '-1',
        keyword: '',
        pageNum: 1,
        pageSize: 10
      }).then((res) => {
        if (res.result == 1) {
          this.swpierList = res.dataList && res.dataList.map(item => {
            item.adv_pic = JSON.parse(item.adv_pic)[0].url
            return item
          })
        } else {
          this.$message(res.msg)
        }
      });
    },
    getList() {
      searchCase({...this.form}).then(res => {
        this.list = res.data
      })
    },
    showDialog(data) {
      this.info = data
      this.showPopup = true
    },
    closeDialog() {
      this.showPopup = false
    },
    handleSignUp() {
      if (!('id' in this.userInfo)) {
        this.$emit('needLogin', true)
        return false
      }
      if (this.isClickSignUp) {
        return false
      }
      this.isClickSignUp = true
      if (!isPhone(this.signupForm.mobile)) {
        this.$message('请输入手机号')
        this.isClickSignUp = false
        return
      }
      if (!this.signupForm.name) {
        this.$message('请输入姓名')
        this.isClickSignUp = false
        return
      }
      if (!this.signupForm.address) {
        this.$message('请输入所在地区')
        this.isClickSignUp = false
        return
      }
      const stamp = Date.now()
      const user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
      const open_id = JSON.parse(localStorage.getItem('giftsUser')).open_id || ''
      const token = localStorage.getItem('token')
      const key = atob(localStorage.getItem('key'))
      const { name, mobile, address} = this.signupForm
      const sign = md5(`${stamp}${token}${user_id}${key}`)
      axios.post('/interface/addBooking',
        {
          name,
          mobile,
          address,
          open_id,
          user_id,
          token,
          stamp,
          sign
        }
      ).then(res=> {
        if (res.data.result === 1) {
          this.$message({
            message: '预约成功',
            type: 'success'
          })
          this.signupForm = {
            name: '',
            mobile: '',
            address: ''
          }
          this.showSuccess = true
        } else {
          this.$message(res.data.msg)
          this.isClickSignUp = false
        }
      }).catch((err) => {
        this.isClickSignUp = false
        console.log(err)
      })
    },
    goEntry(index) {
      console.log(this.activeEntryIndex)
      if (index == 2) {
        this.$router.push('/family/index')
        return
      }
      this.activeEntryIndex = index
      if (index == 0) {
        this.$nextTick(() => {
          this.$refs.houseSelect.gohouse()
        })
      }
    },
    goinfo(info) {
      console.log('goinfo213123')
      this.info = info
      this.showPopup = true
    }
  }
}
</script>
<style lang='less' scoped>
.activity {
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  background: #DEDEDE;
  .banner {
    position: relative;
    .kv {
      width: 100%;
    }
  }
  .quickentry {
    height: 198px;
    padding: 0 200px;
    background: #4E8B46;
    display: flex;
    justify-content: space-around;
    .entry-item {
      width: 208px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;
      &:after {
        content: '';
        width: 2px;
        height: 120px;
        background: url(../../../assets/renew/line.png) no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        right: -90px;
        top: 50%;
        transform: translateY(-50%);
      }
      &:nth-last-child(1) {
        &:after {
          display: none;
        }
      }
      &:hover .icon {
        animation: imageScale 1s forwards;
      }
      &:hover .name {
        animation: imageScale 1s forwards;
      }
      &.active {
        .icon {
          transform: scale(1.1);
        }
        &:hover {
          .name, .icon {
            animation: unset;
          }
        }
        .name {
          font-size: 24px;
          font-weight: 600;
        }
      }
      .name {
        font-size: 20px;
        color: #FFFFFF;
        margin-top: 28px;
      }
      .line {
        width: 168px;
        height: 11px;
        background: #FFFFFF;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      &:nth-child(1) {
        .icon {
          width: 54px;
          height: 55px;
        }
      }
      &:nth-child(2) {
        .icon {
          width: 66px;
          height: 61px;
        }
      }
      &:nth-child(3) {
        .icon {
          width: 62px;
          height: 70px;
        }
      }
      &:nth-child(4) {
        .icon {
          width: 64px;
          height: 64px;
        }
      }
    }
  }
  .container {
    width: 100%;
    max-width: 1920px;
    
  }
  .activity-swiper {
    width: 100%;
    max-width: 1920px;
    max-height: 585px;
    margin: 0 auto;
    .swiper-box {
      width: 100%;
      height: 100%;
      max-width: 1920px;
      max-height: 585px;
      position: relative;
      .oneSwiper {
        position: absolute;
        left:0;
        top: 0;
        bottom: 0;
        .signup-btn {
          width: 262px;
          height: 80px;
          position: absolute;
          bottom: 110.5px;
          left: 50%;
          transform: translateX(-50%);
          cursor: pointer;
        }
      }
      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        object-fit: cover;
      }
      .scale {
        animation: imageScale 1s forwards;
      }
      .content {
        width: 100%;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title {
          font-size: 48px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 25px;
          margin-bottom: 32px;
        }
        .descr {
          font-size: 28px;
          color: #FFFFFF;
          line-height: 36px;
          margin: 0 auto;
          p {
            margin: 0;
          }
        }
      }
      // .content.textAnimated {
      //   // animation: textFadeupin  1.6s forwards;
      // }
    }
    /deep/ .el-carousel__container {
      height: 585px;
      max-height: 585px;
    }
    /deep/ .el-carousel__indicators {
      bottom: 37px;
    }
    /deep/ .el-carousel__button {
      width: 68px;
      height: 8px;
      background: #fff;
      display: none;
    }
    // /deep/ .el-carousel__indicator.is-active {
    //   .el-carousel__button{
    //     background: #009538
    //   }
    // }
  }
  .signup {
    position: absolute;
    top: 50%;
    right:  106px;
    transform: translateY(-50%);
    background: #FFFFFF;
    padding: 50px;
    border-radius: 25px;
    /deep/ .first-floor {
      width: 519px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 25px;
      .label {
        flex: 1;
        height: 50px;
        padding: 0 10px;
        border: 1px solid #B8D4B4;
        border-radius: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-input__inner {
          border: 0;
          outline: none;
          font-size: 18px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #000;
        }
        .el-cascader {
          width: 100%;
        }
      }
    }
    .submit-box {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 60px;
      .loginBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 480px;
        height: 58px;
        background: #4E8B46;
        border-radius: 25px 25px 25px 25px;
        border: 1px solid #4E8B46;
        font-size: 32px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #FFFFFF;
        margin: 0 auto 19px auto;
        cursor: pointer;
        -webkit-user-select: none;
        .el-icon-loading {
          font-size: 32px!important;
        }
        &.cancel {
          color: #4E8B46;
          background: #fff;
        }
      }
    }
  }
  .backtop {
    width: 70px;
    height: 70px;
  }
}
</style>
<style>
@keyframes imageScale {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}
</style>